import styled, { css } from 'styled-components';
import {
    BACKGROUND_DEEP,
    CONTENT_BACKUP,
    CONTENT_BASE,
    NEGATIVE_BASE,
    PRIMARY_HOVER,
    PRIMARY_PRESS,
    SURFACE_BASE,
    TERTIARY_BORDER,
} from '@amzn/ring-common-style-library/lib/colors';
import {
    BODY_NORMAL_LIGHT,
    FOOTNOTE_XSMALL_LIGHT,
} from '@amzn/ring-common-style-library/lib/typography';

const Footer = styled.div<{ disabled?: boolean; }>`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    width: 100%;

    background: ${({ disabled }) => (disabled ? BACKGROUND_DEEP : SURFACE_BASE)};
    border-top: 1px solid ${TERTIARY_BORDER};
`;

const ChatEnded = styled.div`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 343px;
    min-height: 48px;

    padding: 8px 12px;
    box-sizing: border-box;

    ${BODY_NORMAL_LIGHT};
    color: ${CONTENT_BASE};
`;

const Input = styled.div<{ windowType: 'mobile' | 'tablet' | 'desktop' }>`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    align-items: center;
    width: 100%;

    div {
        flex: 1 1 auto;
    }

    .tiptap {
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        flex-shrink: 0;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        min-height: 48px;
        max-height: 80px;
        overflow: auto;

        word-break: break-word; /* Force words to break */
        white-space: pre-wrap; /* Ensure text wraps normally */
        overflow-wrap: break-word; /* Wrap unbroken words (urls) */

        padding: 8px 35px 8px 12px;
        box-sizing: border-box;
        border-radius: 8px;
        border: 1px solid ${TERTIARY_BORDER};

        ${BODY_NORMAL_LIGHT};
        color: ${CONTENT_BASE};

        background: ${BACKGROUND_DEEP};

        /* Mobile/Tablet - Prevent auto-zoom on iOS devices (min 16px required) */
        font-size: ${({ windowType }) => (windowType === 'desktop' ? '0.875rem' : 'clamp(16px, 1rem, 3rem)')};

        p {
            margin: 0;
        }
    }

    /* placeholder text support */
    .tiptap p.is-editor-empty:first-child::before {
        color: rgba(var(--background-primary-color-inverse-rgb), 0.6);
        font-size: 14px;
        content: attr(data-placeholder);
        float: left;
        height: 0;
        pointer-events: none;
    }

    .ProseMirror:focus {
        border: 1px solid ${PRIMARY_HOVER};
        outline: none;
  }
`;

const Loader = styled.div`
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    position: absolute;
    top: 12px;
    right: 16px;
`;

const Mic = styled.div`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    cursor: pointer;
`;

const Send = styled.div<{ disabled?: boolean; }>`
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    position: absolute;
    top: 48%;
    right: 16px;
    transform: translateY(-50%);

    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

    // set icon color (disabled, default, hover, active)
    svg path {
        fill: ${({ disabled }) => (disabled ? TERTIARY_BORDER : CONTENT_BASE)};
    }

    ${({ disabled }) =>
        !disabled &&
        css`
      &:hover svg path {
        fill: ${PRIMARY_HOVER};
      }
      &:active svg path {
        fill: ${PRIMARY_PRESS};
      }
    `}
`;

const Subtext = styled.div`
    ${FOOTNOTE_XSMALL_LIGHT};
    color: ${CONTENT_BACKUP};  
    text-align: center;
    width: 100%;
`;

const OverLimitDisplay = styled.div`
    background-color: ${NEGATIVE_BASE};
    color: #FFFFFF; // white text regardless of theme
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 0.75rem;
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 3; // overlay editorContent
`;

export default {
    ChatEnded,
    Footer,
    Input,
    Loader,
    Mic,
    Send,
    Subtext,
    OverLimitDisplay,
};
